// One registry for the next path's window globals, so teardown cannot forget one.
// Notes: ~/comments/aos-threejs-poc/ogsDebug_publishDebug_registry.md

import { OGS_DEBUG_GLOBALS, type OgsDebugGlobals, type OgsDebugName } from "./debugSchema.ts";

const declared = new Set<string>(OGS_DEBUG_GLOBALS);
const published = new Set<OgsDebugName>();

/** Publish a declared global. An undeclared name is a programming error, not a new seam. */
export function publishDebug<K extends OgsDebugName>(name: K, value: OgsDebugGlobals[K]): void {
  if (!declared.has(name)) throw new Error(`[ogs] '${name}' is not in OGS_DEBUG_GLOBALS — declare it in debugSchema.ts`);
  published.add(name);
  if (typeof window === "undefined") return;
  // Reflect, not an index cast: the name is dynamic and `window` has no index signature.
  Reflect.set(window, name, value);
}

export function retractDebug(name: OgsDebugName): void {
  published.delete(name);
  if (typeof window === "undefined") return;
  Reflect.deleteProperty(window, name);
}

/** Character switch / unmount: drop every global this path published. */
export function retractAllDebug(): void {
  for (const name of [...published]) retractDebug(name);
}

/** Test seam: what is published right now. */
export function publishedDebugNames(): OgsDebugName[] {
  return [...published];
}
